import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {BankInteractor} from "../../interactors/bank.interactor";
import {BankAccountInteractor} from "../../interactors/bank-account.interactor";
import {UserInteractor} from "../../interactors/user.interactor";
import {BankDetailsComponent} from "../bank-details.component";
import {LoanApplicationInteractor} from "../../interactors/loan-application.interactor";

@Component({
    selector: 'app-bank-details-by-ifsc',
    templateUrl: './bank-details-by-ifsc.component.html',
    styleUrls: ['../../loan-application-flow-component/application-flow.css', './bank-details-by-ifsc.component.css']
})
export class BankDetailsByIfscComponent extends BankDetailsComponent implements OnInit, AfterViewInit {
    constructor(formBuilder: FormBuilder, protected bankInteractor: BankInteractor, protected bankAccountInteractor: BankAccountInteractor, protected userInteractor: UserInteractor, loanApplicationInteractor: LoanApplicationInteractor) {
        super(bankInteractor, bankAccountInteractor, userInteractor, loanApplicationInteractor);

        this.searchBankFormGroup = formBuilder.group({
            ifscCode: new FormControl(null, [Validators.pattern(/^[a-zA-Z0-9-\/ ]+$/), Validators.required]),
            bankName: new FormControl(),
            bankCity: new FormControl(),
            bankBranchName: new FormControl()
        });
    }

    async searchBankByIfsc(ifsc: string): Promise<void> {
        const bankDetails = await this.bankInteractor.getBankDetailsByIfscCode(ifsc);
        this.searchBankFormGroup.patchValue({
            ifscCode: bankDetails.ifsc,
            bankName: bankDetails.name,
            bankCity: bankDetails.city,
            bankBranchName: bankDetails.branch
        });

        this.showAccountDetailsSection = true;
    }

    public clearFieldsForIfsc(): void {
        this.searchBankFormGroup.controls.bankName.reset();
        this.searchBankFormGroup.controls.bankCity.reset();
        this.searchBankFormGroup.controls.bankBranchName.reset();
        super.clearBankAccountFields();
        this.showAccountDetailsSection = false;
    }
}
